const Util = require('./Util');

const ResourceCatalogUtil = {};

/** 
 * @param opts
 * @param opts.treeId
 * @param opts.nodeId
 * @param opts.treeSet
 * @param opts.url
 * @param opts.httpRequest
 */
ResourceCatalogUtil.statTree = function(opts) {
    return new Promise(async(resolve, reject) => {
        let statResult = {};
        let statistics = {};
        let treeNodes = null;
        if (opts.treeSet.hasOwnProperty(opts.treeId)) {
            treeNodes = opts.treeSet[opts.treeId];
        }
        let tableStatistics = await this._statTableNodes(treeNodes, opts.url, opts.httpRequest);
        let visitChildren = (node, currentNode) => {
            if (currentNode.children) {
                for (let i = 0; i < currentNode.children.length; i++) {
                    visitChildren(node, currentNode.children[i]);
                }
            } else if (currentNode.ext) {
                statistics[node.id].dataCount += tableStatistics[currentNode.id].total;
                statistics[node.id].resourceCount++;
            }
        }
        let eachNode = (node) => {
            statistics[node.id] = statistics[node.id] || {
                dataCount: 0,
                resourceCount: 0
            };
            visitChildren(node, node);
            if (node.children) {
                for (let i = 0; i < node.children.length; i++) {
                    eachNode(node.children[i]);
                }
            }
        }
        for (let i = 0; i < treeNodes.length; i++) {
            eachNode(treeNodes[i]);
        }
        statResult.statistics = statistics;
        resolve(statResult);
    });
}

//
ResourceCatalogUtil._statTableNodes = function(treeNodes, url, httpRequest) {
    return new Promise(async(resolve, reject) => {
        let statistics = {};
        let aggregateList = [];
        let eachNode = (node) => {
            if (node.children) {
                for (let i = 0; i < node.children.length; i++) {
                    eachNode(node.children[i]);
                }
            } else if (node.ext && node.ext.table) {
                let aggregateObj = {};
                aggregateObj.query = {};
                aggregateObj.searchId = node.id;
                aggregateObj.dataSetId = node.ext.table;
                aggregateObj.queryIndex = 0;
                let aggregate = [];
                aggregate.push({
                    "$group": {
                        "_id": "_id",
                        "v": {
                            "$sum": 1
                        }
                    }
                });
                aggregateObj.aggregate = aggregate;
                aggregateList.push(aggregateObj);
            } else if (node.ext) {
                statistics[node.id] = {
                    total: 0
                };
            }
        }
        for (let i = 0; i < treeNodes.length; i++) {
            eachNode(treeNodes[i]);
        }
        if (aggregateList.length > 0) {
            let aggregateResult = await Util.aggregateMulti({
                url: url,
                httpRequest: httpRequest,
                aggregateList: aggregateList
            });
            for (let nodeId in aggregateResult) {
                let resultObj = aggregateResult[nodeId];
                let list = resultObj[Object.keys(resultObj)[0]];
                statistics[nodeId] = {
                    total: list[0].v
                }
            }
        }
        resolve(statistics);
    });
}



module.exports = ResourceCatalogUtil;